import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'src/app/services/toast.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-password-change',
  templateUrl: './password-change.component.html',
  styleUrl: './password-change.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PasswordChangeComponent implements OnInit {
  constructor(private ToastService: ToastService) {}

  @Input() resetCode?: string;
  @Input() Entry!: FormGroup<{
    password: FormControl<string>;
    passwordConfirm: FormControl<string>;
  }>;

  @Output() passwordErrorEvent = new EventEmitter<{
    error:
      | 'passwordLength'
      | 'passwordUppercase'
      | 'passwordLowercase'
      | 'passwordSpecialCharacter'
      | 'passwordNumber'
      | 'passwordMatch';
  } | null>();

  ngOnInit(): void {
    if (!this.Entry) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing password entry form.',
        { returnError: true }
      );
    }
  }
}
